__webpack_require__.p = "/splitly/";